import axiosClient from 'api/axiosClient';
import Utils from 'general/utils/Utils';

const agencySaleReportApi = {
  // lay bao cao chi tiet
  getAgencySaleReport: (params) => {
    const url = `/agency/sale/report`;
    return axiosClient.get(url, { params });
  },

  // lay lich su ban hang cua dai ly
  getAgencySaleList: (params) => {
    const url = '/sale';
    return axiosClient.get(url, { params });
  },

  // lay lich su thuong doanh so
  getAgencySalePayment: (params) => {
    const url = '/agency/sale/payment';
    return axiosClient.get(url, { params: Utils.filterParams(params) });
  },

  // lay chi tiet don hang
  getOrderDetail: (id) => {
    const url = `/sale/${id}`;
    return axiosClient.get(url);
  },
};

export default agencySaleReportApi;
